import L from 'leaflet';
import { keyBy, toPairs } from 'lodash/fp';
import { ISegmentation } from '../../annotations.interface';
import { AttributePopup } from './AttributePopup';

export class AttributesPopupDrawer {
  private _map: L.Map;
  private _group: L.FeatureGroup = L.featureGroup();
  private _selectedSegmentation?: ISegmentation;
  private _segmentations: Map<string, ISegmentation> = new Map<string, ISegmentation>();
  private _selectedAttributes: string[] = [];
  private _showHeaders: boolean = false;
  private _popups: Map<string, AttributePopup> = new Map<string, AttributePopup>();

  constructor(map: L.Map) {
    this._map = map;
    this._group = L.featureGroup();
    this._group.addTo(this._map);
  }

  public refresh(selected: ISegmentation | undefined, selectedAttributes: string[], segmentations: ISegmentation[], showHeaders: boolean): void {
    this._selectedSegmentation = selected;
    this._showHeaders = showHeaders;
    this._selectedAttributes = selectedAttributes;
    this._segmentations = new Map(toPairs(keyBy((s) => s.feature.id, segmentations)));

    if (!this._selectedAttributes.length) {
      this.clear();
      return;
    }

    const lowOpacity = this._selectedSegmentation !== undefined;

    this._popups.forEach((attributePopup, key) => {
      const segmentation = this._segmentations.get(key);
      if (this._selectedSegmentation?.feature.id === key || !segmentation || !segmentation.bbox.equals(attributePopup._bbox)) {
        this._group.removeLayer(attributePopup);
        attributePopup.remove();
        this._popups.delete(key);
      } else {
        attributePopup.updateData(lowOpacity, false, this._showHeaders, this._selectedAttributes, segmentation);
      }
    });

    this._segmentations.forEach((s: ISegmentation) => {
      if (s.questions.length && s.feature.id !== this._selectedSegmentation?.feature.id && !this._popups.has(s.feature.id)) {
        this._popups.set(
          s.feature.id,
          new AttributePopup(s, this._map, this._group, this._selectedSegmentation !== undefined, this._showHeaders, this._selectedAttributes)
        );
      }
    });
  }

  public hover(key: string): void {
    const lowOpacity = this._selectedSegmentation !== undefined;
    this._popups.get(key)?.updateData(lowOpacity, true, this._showHeaders, this._selectedAttributes, undefined);
  }

  public hout(key: string): void {
    const lowOpacity = this._selectedSegmentation !== undefined;
    this._popups.get(key)?.updateData(lowOpacity, false, this._showHeaders, this._selectedAttributes, undefined);
  }

  public clear(): void {
    this._group.clearLayers();
    this._popups.clear();
  }
}
